import QuickMessagesComponent from "./QuickMessagesComponent";

export default QuickMessagesComponent;
